import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { appActions } from '../../app/reducer/app-reducer';
import { deleteLoginCookie } from '@rosetta/react-auth';

//*********************************************
export class Logout extends PureComponent {
  componentWillMount = () => {
    deleteLoginCookie();
    this.props.logoutUser();
  };

  render = () => {
    return null;
  };
}

const mapStateToProps = (state, ownprops) => ({});

const wrapActions = { logoutUser: appActions.logoutUser };
export const LogoutContainer = connect(
  mapStateToProps,
  wrapActions
)(Logout);



// WEBPACK FOOTER //
// ./src/modules/login/components/Logout.jsx